import React from 'react';
import { BaseForeignIdMapModal } from './BaseForeignIdMapModal';
import { useGetExternalOffices, useSetOfficeForeignId } from '../../services/foreignService';
import { useQueryClient } from 'react-query';
import { useMessage } from '../../helpers/useMessages';
import { queryEnums } from '../../config/queryEnums';

interface OfficeForeignIdMapModalProps {
    officeId: string;
    open: boolean;
    onClose: () => void;
}

export const OfficeForeignIdMapModal: React.FC<OfficeForeignIdMapModalProps> = ({
    officeId,
    open,
    onClose
}) => {
    const queryClient = useQueryClient();
    const { sendSuccess, sendError } = useMessage();
    const setForeignIdMutation = useSetOfficeForeignId();

    // Using external offices as candidates
    const { data: externalOffices = [], isLoading, error } = useGetExternalOffices();
    
    // Transform the external offices to have the expected structure
    const candidates = externalOffices.map(office => ({
        foreignId: office.id,
        name: office.name,
        description: office.description || ''
    }));

    const handleSelect = (foreignId: string | number) => {
        setForeignIdMutation.mutate({ 
            officeId, 
            foreignId: foreignId as number 
        }, {
            onSuccess: () => {
                sendSuccess('Office foreign ID set successfully');
                queryClient.invalidateQueries(queryEnums.foreign_unmapped_offices);
                queryClient.invalidateQueries(queryEnums.foreign_mapped_offices);
                onClose();
            },
            onError: (error: any) => {
                sendError(`Failed to set office foreign ID: ${error.message}`);
            }
        });
    };

    return (
        <BaseForeignIdMapModal
            open={open}
            onClose={onClose}
            title="Map Office to External System"
            candidates={candidates}
            isLoading={isLoading}
            error={error as Error}
            onSelect={handleSelect}
        />
    );
}; 